module.exports = __webpack_public_path__ + "static/media/thumbs-up.bf12c4d7.svg";